import type { Language } from './valueObjects/language';
import type { UserAgent } from './valueObjects/userAgent';
import type { DeviceInfoJson } from '@/types/domain/device/entities/deviceInfoEntity';

import { EntityPvt } from '@/domain/entityPvt';
import { EntityNamePvt } from '@/types/common/entityPvt';

/**
 * デバイス情報プロパティ
 */
export type DeviceInfoProps = {
  /** ユーザエージェント */
  userAgent: UserAgent,
  /** 言語 */
  language: Language,
}

/**
 * デバイス情報Entity
 */
export class DeviceInfoEntity extends EntityPvt<
  DeviceInfoProps,
  DeviceInfoJson
> {
  /**
   * データJsonを返す
   * @returns データ
   */
  toJsonData(): DeviceInfoJson {
    return {
      userAgent: this.userAgent.value,
      language: this.language.value,
    };
  }

  /**
   * Entity名
   */
  get entityName(): EntityNamePvt {
    return EntityNamePvt.WagakoNurseryDeviceDeviceInfoEntity;
  }

  /**
   * Entityキー
   */
  get entityKey(): string {
    return this.userAgent.value;
  }

  /**
   * ユーザーエージェント
   */
  get userAgent(): UserAgent {
    return this._value.userAgent;
  }

  /**
   * 言語
   */
  get language(): Language {
    return this._value.language;
  }
}
